module.exports = __webpack_public_path__ + "static/pay-by-link-screenshot-50e0c81e11437468074cc94dbb8bfe6c.png";